module.exports = __webpack_public_path__ + "img/methods-min.da5e64df.jpg";